module.exports = __webpack_public_path__ + "deab05d4bc085540c0aa0a194b975e3c.jpg";